import {
  IAdvancedRichText,
  IAdvancedRichTextItem,
} from '../../IAdvancedRichText';
import { TooltipVirtualNode } from '../nodes/TooltipVirtualNode';

interface IPostprocessingAdvancedRichTextItem extends IAdvancedRichTextItem {
  skip: boolean;
}

const LATEST_CLOSING_TAGS = /(<\/[a-zA-Z]+>)+$/gm;

/**
 * Per il testo avanzato, esegue il postprocessing del testo per aggiungere
 * il tooltip nella posizione corretta.
 *
 * A livello di visualizzazione, il tooltip viene gestito
 * da `renderRichTextAdvancedNodes` che si occupa di renderizzare il tooltip
 * come un componente React.
 */
export function postprocessRichTextAdvancedHtml(
  richtext: IAdvancedRichText,
): IAdvancedRichText {
  const processing: IPostprocessingAdvancedRichTextItem[] = richtext.map(
    item => ({
      ...item,
      skip: false,
    }),
  );

  // Ultimo elemento di testo processato sul quale aggiungere i Tooltip
  let lastValidIndex: number | null = null;

  for (let i = 0; i < processing.length; i++) {
    const item = processing[i];

    if (item.type == 'text') {
      lastValidIndex = i;
      continue;
    }

    // Spostiamo il tooltip sul testo precedente, alla fine
    if (lastValidIndex != null && item.type == 'info') {
      processing[lastValidIndex].text = addTooltipInHtml(
        processing[lastValidIndex],
        item,
      );
      processing[i].skip = true;
      continue;
    }
  }

  const processed = processing.filter(item => !item.skip);

  return processed;
}

/**
 * Aggiunge il tooltip nell'HTML del testo avanzato precedente, in modo
 * da poterlo renderizzare inline.
 */
function addTooltipInHtml(
  prev: IPostprocessingAdvancedRichTextItem,
  item: IPostprocessingAdvancedRichTextItem,
) {
  if (!prev.text || prev.text.length === 0) return prev.text; // Caso non gestito
  if (!item.text) return prev.text; // Caso non gestito

  const html = prev.text;
  return html.replace(LATEST_CLOSING_TAGS, (match, p1) => {
    const tooltipSpan = document.createElement('span');
    tooltipSpan.setAttribute('data-type', TooltipVirtualNode.name);
    tooltipSpan.setAttribute('data-content', item.text!);
    const tooltip = tooltipSpan.outerHTML;

    // console.log(`[addTooltipInHtml] Aggiungo il tooltip ${tooltip} a ${match}`);
    return `${tooltip}${match}`;
  });
}
